"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedStyles = exports.getHoverStyles = void 0;
var _styledComponents = require("styled-components");
var _TableCell = _interopRequireDefault(require("../TableCell"));
var _TableCellFlex = _interopRequireDefault(require("../TableCellFlex"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getHoverStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &:hover > ", ", &:hover > ", " {\n    background-color: unset;\n    color: unset;\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), _TableCell["default"], _TableCellFlex["default"], function (_ref) {
  var isSelected = _ref.isSelected,
    theme = _ref.theme;
  return isSelected ? theme.tableRowSelectedBackgroundColor : theme.tableRowHoverBackgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.tableRowHoverColor;
});
exports.getHoverStyles = getHoverStyles;
var getSelectedStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  ", ", ", " {\n    color: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.tableRowSelectedBackgroundColor;
}, _TableCell["default"], _TableCellFlex["default"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.tableRowHoverColor;
});
exports.getSelectedStyles = getSelectedStyles;